import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

interface NewsletterContextType {
  isOpen: boolean;
  openPopup: () => void;
  closePopup: () => void;
}

const NewsletterContext = createContext<NewsletterContextType | undefined>(undefined);

export const NewsletterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openPopup = useCallback(() => setIsOpen(true), []);
  const closePopup = useCallback(() => setIsOpen(false), []);

  const value = useMemo(() => ({ isOpen, openPopup, closePopup }), [isOpen, openPopup, closePopup]);

  return <NewsletterContext.Provider value={value}>{children}</NewsletterContext.Provider>;
};

export const useNewsletter = () => {
  const context = useContext(NewsletterContext);
  if (!context) {
    throw new Error('useNewsletter must be used within NewsletterProvider');
  }
  return context;
};
